import { LineItemModels } from "@grandvisionhq/lib-visuals";
import { getLocalizedString, isNil } from "@grandvisionhq/utils";
import { PrescriptionType } from "../../../../../../models/line-item/models/line-item/prescription-glasses.js";
import { toBaseLineItem } from "./base-line-item.js";
import { getLineItemProduct } from "../../../utils/mappers/view/visual-line-item/utils/get-line-item-product.js";
import { getLineItemImageUrl } from "../../../../../../utils/utils/get-line-item-image-url.js";
import { getLineItemAvailability } from "../../../../../../utils/utils/get-line-item-availability.js";
import { mapBundleChildLineItems } from "../../../utils/mappers/view/visual-line-item/utils/map-bundle-child-line-items.js";
import { getProductA11yLabel } from "../../../utils/mappers/view/visual-line-item/utils/get-product-a11y-label.js";
import { getAttribute } from "../../../../../../utils/utils/get-line-item-attribute.js";
function toLens(lens) {
  const { pupillaryDistance, power, cylinder, axis, addition } = lens;
  return {
    ...!isNil(pupillaryDistance) ? { pupillaryDistance: pupillaryDistance.toString() } : null,
    ...!isNil(power) ? { power: power.toString() } : null,
    ...!isNil(cylinder) ? { cylinder: cylinder.toString() } : null,
    ...!isNil(axis) ? { axis: axis.toString() } : null,
    ...!isNil(addition) ? { addition: addition.toString() } : null
  };
}
function getPrescription(typeDetails) {
  const hasLeftLensPupillaryDistance = Boolean(
    typeDetails.newPrescription?.leftLens.pupillaryDistance
  );
  const hasRightLensPupillaryDistance = Boolean(
    typeDetails.newPrescription?.rightLens.pupillaryDistance
  );
  const hasPupillaryDistanceFile = Boolean(typeDetails.pupillaryDistanceFile);
  const hasLeftAndRightLens = Boolean(typeDetails.newPrescription?.leftLens) && Boolean(typeDetails.newPrescription?.rightLens);
  const hasLeftAndRightPupillaryDistance = hasLeftLensPupillaryDistance && hasRightLensPupillaryDistance;
  if (typeDetails.newPrescription && !typeDetails.isOCRPrescription && typeDetails.prescriptionFile && hasLeftAndRightLens && (hasPupillaryDistanceFile && !hasLeftAndRightPupillaryDistance || !hasPupillaryDistanceFile && hasLeftAndRightPupillaryDistance)) {
    return {
      type: PrescriptionType.PRESCRIPTION_WITH_MANUAL_XOR_FILE_PUPILLARY_DISTANCE,
      prescriptionFile: typeDetails.prescriptionFile.fileName,
      pupillaryDistanceFile: typeDetails.pupillaryDistanceFile?.fileName,
      ...typeDetails.newPrescription?.leftLens && {
        leftEye: toLens(typeDetails.newPrescription.leftLens)
      },
      ...typeDetails.newPrescription?.rightLens && {
        rightEye: toLens(typeDetails.newPrescription.rightLens)
      }
    };
  }
  if (typeDetails.isOCRPrescription && typeDetails.newPrescription && typeDetails.prescriptionFile && typeDetails.pupillaryDistanceFile) {
    return {
      type: LineItemModels.PrescriptionType.OCR_PRESCRIPTION,
      prescriptionFile: typeDetails.prescriptionFile.fileName,
      pupillaryDistanceFile: typeDetails.pupillaryDistanceFile.fileName
    };
  } else if (typeDetails.newPrescription) {
    return {
      type: LineItemModels.PrescriptionType.NEW_PRESCRIPTION,
      leftEye: toLens(typeDetails.newPrescription.leftLens),
      rightEye: toLens(typeDetails.newPrescription.rightLens)
    };
  } else if (typeDetails.isEmailPrescription) {
    return {
      type: LineItemModels.PrescriptionType.EMAIL_PRESCRIPTION
    };
  } else if (typeDetails.isExistingCustomer) {
    return {
      type: LineItemModels.PrescriptionType.EXISTING_CUSTOMER
    };
  } else if (typeDetails.prescriptionFile && typeDetails.pupillaryDistanceFile) {
    return {
      type: LineItemModels.PrescriptionType.PRESCRIPTION_FILE,
      prescriptionFile: typeDetails.prescriptionFile.fileName,
      pupillaryDistanceFile: typeDetails.pupillaryDistanceFile.fileName
    };
  }
  throw new Error("Missing prescription details in visual line item mapper");
}
const toGlassesBundleCartLineItem = (lineItem, typeDetails, intl, settings, apiUrl) => {
  const product = getLineItemProduct(lineItem);
  const variant = product.masterData.current.variant;
  const imageUrl = getLineItemImageUrl(variant);
  const packageNames = lineItem.bundleLineItems.reduce((subtitle, childLineItem) => {
    if (childLineItem.isMainBundleLineItem) {
      return subtitle;
    }
    return `${subtitle}${getLocalizedString(
      childLineItem.legacyProduct.masterData.current.name,
      intl.locale
    )}, `;
  }, "").slice(0, -2);
  return {
    ...toBaseLineItem(lineItem, settings, intl),
    imageUrl,
    subProductType: product.productType,
    type: "GLASSES_BUNDLE",
    productType: "prescription-glasses",
    title: `${getAttribute(variant, "brand")} ${getAttribute(variant, "brandModel")}`,
    subtitle: packageNames,
    altText: getProductA11yLabel(lineItem, intl),
    prescription: getPrescription(typeDetails),
    bundleChildLineItems: mapBundleChildLineItems(lineItem, intl),
    ...variant.availability ? { availability: getLineItemAvailability(variant.availability) } : {},
    quoteConfig: lineItem?.quote?.quoteToken ? {
      quoteUrl: `${apiUrl}/quotes/${lineItem.quote.quoteToken}`,
      hasQuoteLink: Boolean(settings.shouldShowQuoteLink)
    } : void 0
  };
};
export {
  toGlassesBundleCartLineItem
};
//# sourceMappingURL=glasses-bundle-line-item.js.map
